import { postJSON, post, get } from '@/utils/axios'

/**
 * 门店端
 */
// 门店端-质保卡头部统计
interface optionsProps {
    orgPk?: string //门店pk
    page?: string | number //当前页
    size?: string | number //每页大小
    startTime?: string //发卡开始日期
    endTime?: string //发卡截止日期
    projectPk?: string //iot项目pk
    carNo?: string //车牌号
    brandName?: string //车辆品牌
    technicianPk?: string //施工技师pk
    constructionStartTime?: string //施工开始日期
    constructionEndTime?: string //施工截止日期
    createBillPk?: string //开单人pk
    status?: string //0-有效质保卡 1-过期质保卡 2-预约到店 3-30天内到期
    minDay?: string //离过期最小天数
    maxDay?: string //离过期最大天数
}
export const getOrgWarrantyCardListStatistics = (options:optionsProps) => postJSON('warrantyCard/orgWarrantyCardListStatistics', options)

// 门店端-质保卡发卡列表统计
export const getOrgSendWarrantyCardListStatistics = (options:optionsProps) => postJSON('warrantyCard/orgSendWarrantyCardListStatistics',options)

// 门店端-质保卡预约到店列表统计
export const getOrgWarrantyCardAppointmentListStatistics = (options:optionsProps) => postJSON('warrantyCard/orgWarrantyCardAppointmentListStatistics',options)

// 门店端-质保卡列表
export const getSelectWarrantyCardList = (options:optionsProps) => postJSON('warrantyCard/selectWarrantyCardList',options)

/**
 * 商户端
 */
// 商户端-服务商已发卡iot项目列表
export const getMerchantSendCardIotProjectList = (orgPk: string) => post('warrantyCard/merchantSendCardIotProjectList', { orgPk })

// 商户端-服务商质保卡列表头部统计
export const getMerchantWarrantyCardListStatistics = (orgPk: string) => post('warrantyCard/merchantWarrantyCardListStatistics', { orgPk })

// 商户端-门店已发卡iot项目列表
export const getOrgSendCardIotProjectList = (orgPk: string) => post('warrantyCard/orgSendCardIotProjectList', { orgPk })

// 商户端-门店发卡明细头部统计
export const getOrgWarrantyCardDetailStatistics = (orgPk: string) => post('warrantyCard/orgWarrantyCardDetailStatistics', { orgPk })

// 商户端-按门店发卡数量排名统计
interface orgWarrantyCardRankStatisticsProps {
    orgPk?: string //门店pk
    page?: string | number //当前页
    size?: string | number //每页大小
    merchantOrgPk?: string //服务商pk
    orgName?: string //门店名称
    startTime?: string //开始日期
    endTime?: string //截止日期
    projectPk?: string //iot项目pk
}
export const getOrgWarrantyCardRankStatistics = (options: orgWarrantyCardRankStatisticsProps) => postJSON('warrantyCard/orgWarrantyCardRankStatistics', options)

//商户端-质保卡统计(新增/过期/预约)
export const getWarrantyCardStatistics = (options: orgWarrantyCardRankStatisticsProps) => postJSON('warrantyCard/warrantyCardStatistics', options)

// 按施工单pk查询质保详情
export const getSelectUserWarrantyCardDetailByConstructionBillPk = (constructionBillPk: string) => post('warrantyCard/selectUserWarrantyCardDetailByConstructionBillPk', { constructionBillPk })

// 按质保卡pk查询质保详情
export const getSelectUserWarrantyCardDetailByWarrantyCardPk = (warrantyCardPk: string) => post('warrantyCard/selectUserWarrantyCardDetailByWarrantyCardPk', { warrantyCardPk })